var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"back_header"},[(_vm.type != 0)?_c('div',{on:{"click":_vm.goUpper}},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"return"},[_c('span',{staticClass:"iconfont iconfanhui"})])
}]

export { render, staticRenderFns }